import { render, staticRenderFns } from "./paginationButtons.vue?vue&type=template&id=72a2a786&scoped=true&"
import script from "./paginationButtons.vue?vue&type=script&lang=js&"
export * from "./paginationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a2a786",
  null
  
)

export default component.exports